export default {"src":"/login-app/[GIT_HASH]/_next/static/media/sort_by_alpha.72d42d2b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};